import { render, staticRenderFns } from "./ResultsPageRoutes.vue?vue&type=template&id=86312726"
import script from "./ResultsPageRoutes.vue?vue&type=script&lang=js"
export * from "./ResultsPageRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports